import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import {
  IFunnelResponse,
  IProtectModeResponse,
  IPermissionStat,
  IErrorsResponse,
  ICallsResponse,
  ILocationResponse,
  ISafetyAlertsResponse,
  IRealtimeStatusResponse,
  IHelpSupportResponse,
} from '~/utils/interface/analytics';

const urlApiAnalytics = {
  funnel: 'analytics/funnel',
  protectMode: 'analytics/protect-mode',
  permissions: 'analytics/permissions',
  errors: 'analytics/errors',
  calls: 'analytics/calls',
  location: 'analytics/location',
  safetyAlerts: 'analytics/safety-alerts',
  realtimeStatus: 'analytics/realtime-status',
  helpSupport: 'analytics/help-support',
};

const analyticsApi = {
  getFunnel() {
    return axiosClient.get<IBaseResponse<IFunnelResponse>>(urlApiAnalytics.funnel);
  },

  getProtectMode() {
    return axiosClient.get<IBaseResponse<IProtectModeResponse>>(urlApiAnalytics.protectMode);
  },

  getPermissions() {
    return axiosClient.get<IBaseResponse<IPermissionStat[]>>(urlApiAnalytics.permissions);
  },

  getErrors() {
    return axiosClient.get<IBaseResponse<IErrorsResponse>>(urlApiAnalytics.errors);
  },

  getCalls() {
    return axiosClient.get<IBaseResponse<ICallsResponse>>(urlApiAnalytics.calls);
  },

  getLocation() {
    return axiosClient.get<IBaseResponse<ILocationResponse>>(urlApiAnalytics.location);
  },

  getSafetyAlerts() {
    return axiosClient.get<IBaseResponse<ISafetyAlertsResponse>>(urlApiAnalytics.safetyAlerts);
  },

  getRealtimeStatus() {
    return axiosClient.get<IBaseResponse<IRealtimeStatusResponse>>(urlApiAnalytics.realtimeStatus);
  },

  getHelpSupport() {
    return axiosClient.get<IBaseResponse<IHelpSupportResponse>>(urlApiAnalytics.helpSupport);
  },
};

export default analyticsApi;
